import { render } from "./FormOpname.vue?vue&type=template&id=6e0a0bf5"
import script from "./FormOpname.vue?vue&type=script&lang=js"
export * from "./FormOpname.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__